import type { Product } from 'reactApp/types/Billing';
import { getPeriodName } from 'reactApp/utils/Period';

export const getPromoContent = (product?: Product) => ({
    buttonText: `Получить ${product?.space.value}`,
    title: `+${product?.space.value} бесплатно`,
    text: `Получите ${product?.space.value} в Облаке бесплатно на ${getPeriodName(product?.trialPeriod || '', true)}`,
});
